import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs';

// Models
import { IPagination } from './table-pagination/pagination.model';


@Component({
  selector: 'lib-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent {

  @Input() columns: string[];
  @Input() $rows: Observable<any[]>;
  @Input() pagination: IPagination;

  @Output() paginationChange = new EventEmitter();

  constructor() { }

  emitNewPagination(newPagination: IPagination) {
    this.paginationChange.emit(newPagination);
  }

  getElemKeys(elem: object) {
    return Object.keys(elem);
  }

}
